<template>
    <div class="transformer-status">      
      <div style="margin-top:1rem" class="transformer-statu">
        <span style="border-right:1px solid blue;width:10rem" class="trend-title">变压器名称</span>
        <span style="border-right:1px solid blue;width:10rem" class="trend-title">运行状态</span>
        <span style="border-right:1px solid blue;width:10rem" class="trend-title">使用状态</span>
        <span style="border-right:1px solid blue;width:10rem" class="trend-title">安装位置</span>
        <i @click="addCar" class="el-icon el-icon-circle-plus-outline f_green" style="margin-top:10px"></i>
      </div>
      <div v-for="(item,index) in transformerDate" :key="index" class="transformer-statu">
        <el-input type="text" v-model="item.devName"></el-input>
        <el-select v-model="item.runStatus" placeholder="请选择">
          <el-option label="关机" :value="0"></el-option>
          <el-option label="正常" :value="1"></el-option>
        </el-select>
        <el-select v-model="item.useStatus" placeholder="请选择">
          <el-option label="待售" :value="0"></el-option>
          <el-option label="正常" :value="1"></el-option>
          <el-option label="待出租" :value="2"></el-option>
        </el-select>
        <el-input type="text" v-model="item.address"></el-input>
        <!-- <el-button @click="removeCar(item.id,index)" style="margin-left:1rem" type="primary" icon="el-icon-minus"></el-button> -->
        <i @click="removeCar(item.id,index)" class="el-icon el-icon-remove-outline f_red"></i>
      </div>
      <div class="last-save" style="margin-top:1rem">
         <el-button :loading="statusLoading" size="small" @click="saveStatu" type="primary">保存</el-button>
      </div>
    </div>
</template>

<script>
import api from '@/apis/power/power'
export default {
  data() {
    return {
      statusLoading:false,//加载状态
  
      transformerDate:[
        {devName:'',runStatus:'',useStatus:'',address:''}
      ]
    }
  },
  mounted() {
    this.getStatu()
  },
  methods: {
    //保存数据
    saveStatu(){
      this.statusLoading = true;
      api.saveDevLoad(this.transformerDate).then(res=>{
        if(res.code==10000){
          this.$message.success('保存成功');
          this.getStatu()
          this.statusLoading = false;
        }else{
          this.$message.error(res.message);
          this.statusLoading = false;    
          return;     
        }
      })
    },
    //获取数据
    getStatu(){
      api.getDevLoad().then(res=>{
        if(res.code==10000){
          if(res.data.list.length!=0){
            this.transformerDate = res.data.list
          }else{
            this.transformerDate = [
              {devName:'',runStatus:'',useStatus:'',address:''}
            ]
          }
        }
      })
    },
    //删除一行车辆
    removeCar(id,index){
      if(id){
        this.$confirm('确认删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          api.delDevLoad(id).then(res=>{
            if(res.code==10000){
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getStatu()
            }else{
              this.$message.error(res.message);
              return;
            }
          })
        })
      }else{
        this.transformerDate.splice(index,1)
      }
    },
    //增加一行车辆
    addCar(){
      this.transformerDate.push({devName:'',runStatus:'',useStatus:'',address:''})
    },
  }
}
</script>
<style lang="less" scoped>
.transformer-status{ padding-top: 10px;
  .jiegou-input{ display: inline-block; margin-right: 15px;
    .el-input{ width: 8rem;}
  }
  .transformer-statu{
    .trend-title{ text-align: center;}
    .el-input,.el-select{ width: 10rem;}
    i{ font-size: 1.2rem; font-weight: bold; margin-left: 1rem; vertical-align: middle;}
  }
}
</style>

